var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0L30.6038 0C32.7742 0 34.8514 0.881852 36.359 2.44324L49.7552 16.3179C51.1952 17.8093 52 19.8015 52 21.8747V51C52 54.866 48.866 58 45 58H7C3.13401 58 0 54.866 0 51V7Z",
    fill: "#66CDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9084 36V24.8H15.3244C17.9484 24.8 19.5804 26.288 19.5804 28.544V28.576C19.5804 31.088 17.5644 32.4 15.1004 32.4H12.8764V36H10.9084ZM12.8764 30.624H15.1644C16.6524 30.624 17.5804 29.792 17.5804 28.624V28.592C17.5804 27.28 16.6364 26.592 15.1644 26.592H12.8764V30.624Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2759 36V24.8H25.4519C28.9719 24.8 31.4039 27.216 31.4039 30.368V30.4C31.4039 33.552 28.9719 36 25.4519 36H21.2759ZM25.4519 26.592H23.2439V34.208H25.4519C27.8039 34.208 29.3399 32.624 29.3399 30.432V30.4C29.3399 28.208 27.8039 26.592 25.4519 26.592Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4716 36V24.8H41.8076V26.592H35.4396V29.648H41.0876V31.44H35.4396V36H33.4716Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.9fbec27d441cc99e07ca387f75e196d8.svg";
export { ForwardRef as ReactComponent };